import { NU0 } from '../../../constants/math';

const { PI, E, log, sqrt, pow, log1p, exp } = Math;

// source: IPC-2141A Equation 4-9
// NOTE: the result from this formual does not match with the formual set2.
// As EEweb seems to be using formula set1, I strongly discourage to use this
// formula until figure out what is wrong with this formula.
export function characteristicImpedanceFormulaSet1(e, h, t, w) {
  const m = (6 * h) / (3 * h + t);
  const weff = w 
    + (t / PI) * log(E/sqrt(pow(t / (4 * h + t), 2) + pow((PI * t) / (4 * (w + 1.1 * t)), m)));
  const hPIwp = h / (PI * weff);
  const logPart = log1p(8*hPIwp * (16*hPIwp + sqrt(pow(16*hPIwp, 2) + 6.27)));
  const z0ss = (NU0 / (2 * PI * sqrt(e))) * logPart;
  
  return z0ss;
}

// source: IPC-2141A Equation 4-12 & 4-15
export function characteristicImpedanceFormulaSet2(e, h, t, w) {
    const b = 2 * h + t;
    const wb = w / b;

    if (wb < 0.35) {
      const D = (w/2)*(1 + (t/(PI*w)) * (1 + log(4*PI*w/t)) + 0.551*pow(t/w, 2));
      return 60/sqrt(e)*log(4*b/(PI*D));

    } else {
      const theta = (2 * b)/(b - t) * log((2 * b - t) / (b - t))
        - ( t / (b -t)) * log((2*b*t - t*t) / pow((b - t), 2));

      return 95.14 / ( wb/(1 - (t/b)) + theta/PI );
    }
}

// source: http://referencedesigner.com/books/si/impedance_calculator_for_stripline.php
// Wadell formula
export function characteristicImpedanceWadellFormual(e, b, t, w) {
const zK1 
  = w/2
      * (
          1
          + t/(PI * w) 
          * (1 + log(4*PI*w/t) + 0.51*PI * ((t/w) ** 2))
        )
  ;

  const zK2 = 2 / (1-t/b) * log(1/(1-t/b) + 1)
    - (1/(1-t/b) - 1) * log(1/pow(1-t/b, 2) - 1);

  const z0 = w/b < 0.35 
    ?  60 / sqrt(e) * log((4 * b) / (PI * zK1))
    :  94.15 / ((w/b) / (1 - t/b) + (zK2 / PI) ) * 1/ sqrt(e)
  ;

  return z0
}

export function characteristicImpedance(params) {
  const{ w, t, e, h } = mapStandardParamsToFormulaParams(params);

  return characteristicImpedanceFormulaSet2(e, h, t, w);
}

// source: http://referencedesigner.com/tutorials/si/si_11.php 
export function differentialImpedance(params) {
  const { d, b } = mapStandardParamsToFormulaParams(params)
  const z0 = characteristicImpedance(params);

  const zDiff = 2 * z0 * (1 - 0.347 * exp(-2.9 * d/b));
  return zDiff;
}

export function propagationalDelay(params) {
  const { e } = mapStandardParamsToFormulaParams(params);

  const tPd = 84.72 * sqrt(e);
  return tPd;
}

export function mapStandardParamsToFormulaParams(params) {
  const {
    dielectricUpHeight,
    dielectricDownHeight,
    dk,
    thickness,
    transmissionSpacing,
    transmissionWidth
  } = params;

  return {
    w: transmissionWidth,
    d: transmissionSpacing,
    t: thickness,
    e: dk,
    h: (dielectricDownHeight + dielectricUpHeight) / 2,
    b: dielectricDownHeight + thickness + dielectricUpHeight,
  }
}

export default {
  characteristicImpedance,
  differentialImpedance,
  propagationalDelay,
}


// WEBPACK FOOTER //
// ./src/lib/simulations/formulas/stripline.js